import { useContext } from 'react';

import { SessionContext } from '../contexts/SessionContext';
import useIsFeatureFlagEnabled from '../graphql/queries/variant/useIsFeatureFlagEnabled';

export enum FeatureFlag {
  ProgressVisits = 'trade_partner-17-01-rollout-progress_visits_for_tp',
  NewWorkOrderPage = 'trade_partner-15-12-rollout-new_work_order_page',
}

export const useFeatureFlagEnabledForProgressVisits = (market: string) => {
  const {
    session: { human },
  } = useContext(SessionContext);
  const userId = human?.token || 'none';
  const branches = human?.organizations.map((org) => org?.name) || [];
  const {
    data: isFeatureFlagEnabled,
    loading: isLoading,
    error,
  } = useIsFeatureFlagEnabled({
    variables: {
      featureFlag: FeatureFlag.ProgressVisits,
      userId,
      props: {
        fields: [
          {
            key: 'market',
            value: { kind: { stringValue: market } },
          },
          {
            key: 'branch',
            value: { kind: { stringValue: branches.join(',') } },
          },
        ],
      },
    },
    skip: !market,
  });
  return isFeatureFlagEnabled && !isLoading && !error;
};

export const useFeatureFlagEnabledForNewWorkOrderPage = () => {
  const {
    session: { human },
  } = useContext(SessionContext);
  const userId = human?.token || 'none';
  const {
    data: isFeatureFlagEnabled,
    loading: isLoading,
    error,
  } = useIsFeatureFlagEnabled({
    variables: {
      featureFlag: FeatureFlag.NewWorkOrderPage,
      userId,
      props: {
        fields: [
          {
            key: 'email',
            value: { kind: { stringValue: human?.email } },
          },
        ],
      },
    },
  });

  return { isEnabled: isFeatureFlagEnabled && !isLoading && !error, isLoading };
};
